// main Import
import React, { useState, useEffect } from "react";

// Custom Css
// import "./executiveDash.css";
import Colors from "../../Global/colors";
import { Chart as GoogleChart } from "react-google-charts";
import Spinner from "../../Global/Spinner2";

// Material UI Components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import calander from "../../Assets/due_inspection.png";
import Table from "@material-ui/core/Table";
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import Chart from "react-apexcharts";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import {useTranslation} from 'react-i18next';
//Images
import up from "../../Assets/UpG.png";
import dots from "../../Assets/dots.png";
import down from "../../Assets/DownG.png";
import NoRecord from "../../Assets/no_records.png";

//Redux
//Redux
import { useSelector, useDispatch } from "react-redux";

function createData(area, current, previous, trend) {
  return { area, current, previous, trend };
}

const rows = [
  createData("Area 1", 19, 6),
  createData("Area 2", 87, 90),
  createData("Area 3", 10, 16),
  createData("Area 4", 62, 16),
];

function createData1(question, Score) {
  return { question, Score };
}
function createData2(question, score, total) {
  return { question, score, total };
}

function createData3(inspection, score, aging, inspector) {
  return { inspection, score, aging, inspector };
}

const rows1 = [
  createData1("Question1", 19),
  createData1("Question2", 87),
  createData1("Question3", 10),
  createData1("Question4", 62),
  createData1("Question5", 19),
  createData1("Question6", 87),
  createData1("Question7", 10),
  createData1("Question8", 62),
];

const rows2 = [
  createData1("Question1", 19.5),
  createData1("Question2", 87.5),
  createData1("Question3", 10.5),
  createData1("Question4", 62.7),
  createData1("Question5", 19.5),
  createData1("Question6", 87.8),
  createData1("Question7", 10.1),
  createData1("Question8", 62.5),
];

const rows3 = [
  createData2("Question1", 5, 12),
  createData2("Question2", 2, 17),
  createData2("Question3", 7, 20),
  createData2("Question4", 12, 58),
  createData2("Question5", 12, 30),
  createData2("Question6", 18, 22),
  createData2("Question7", 5, 8),
  createData2("Question8", 12, 12),
];

const rows4 = [
  createData3("Area 1", 19, 6, "mark"),
  createData3("Area 2", 87, 90, "joe"),
  createData3("Area 3", 10, 16, "tom"),
  createData3("Area 4", 62, 16, "tim"),
  createData3("Area 1", 19, 6, "sam"),
  createData3("Area 2", 87, 90, "lex"),
  createData3("Area 3", 10, 16, "nofe"),
  createData3("Area 4", 62, 16, "samel"),
];

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function ExecutiveDashboard({
  plannedToActual,
  plannedToActualLoader,
  timeliness,
  timelinessLoader,
  failureToActionPlan,
  failureToActionLoader,
  actionPlan,
  actionPlanLoader,
  bottomAreas,
  bottomAreasLoader,
  auditFrequency,
  auditFrequencyLoader,
  companyID,
  to,
  from,
}) {
  const {t} = useTranslation();
  let company = useSelector((state) => state.companyReducer.company);
  const dispatch = useDispatch();
  let DashboardState = useSelector((state) => state.execDashReducer);
  const [responses, setResponses] = useState([]);
  const [currentResponses, setCurrentResponses] = useState([]);
  const [chartNew, setChartNew] = useState({
    series: [10,0,50, 20, 20,0, 0],
    options: {
      chart: {
        width: 380,
        type: 'pie',
      },
      colors: [
        "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
            ],
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val + "%"
        },
      },
  
      labels: ["Custom Month Avg","Custom Week Avg","Custom Day Avg","Every Month Avg","Every Week Avg","Every weekDay Avg","One Off Avg"],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,  
          },
         
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  
  
  });

  const [chart1, setChart1] = useState({
    series: [
      {
        data: [6, 2, 5, 0],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
        yaxis: {
          tickAmount: 3,
          labels: {
            formatter: function(val) {
              return val.toFixed(0)
            }
          },
        },
        zoom: {
          enabled: true,
          type: "x",
          autoScaleYaxis: false,
          zoomedArea: {
            fill: {
              color: "#90CAF9",
              opacity: 0.4,
            },
            stroke: {
              color: "#0D47A1",
              opacity: 0.4,
              width: 1,
            },
          },
        },
        events: {
          click: function(chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },

      colors: [
        "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
            ],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        marker: {
          show: true,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="arrow_box">' +
            "<span> <b> Count: </b>" +
            series[seriesIndex][dataPointIndex] +
            "</span>" +
            "</div>"
          );
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
        showForSingleSeries: false,
      },
      xaxis: {
        categories: [
          "0 - 2",
          "5 - 7",
          "8 - 12",
          ">12",
          // ["0 - 2", 12], ["5 - 7", 5], ["8 - 12", 1], [">12", 0]
        ],
        labels: {
          style: {
            colors: ["#043077"],
            fontSize: "12px",
          },
        },
      },
    },
  });

  const [chart1Options, setChart1Options] = useState({});
  const [chart2Options, setChart2Options] = useState({});
  const [chart3Options, setChart3Options] = useState({});
  const [chart4Options, setChart4Options] = useState({});
  const [chart5Options, setChart5Options] = useState({});

  const [radialChart1, setRadialChart1] = useState({});
  const [radialChart2, setRadialChart2] = useState({});
  const [radialChart3, setRadialChart3] = useState({});



  useEffect(
    () => {
      if (plannedToActual != null) {
        let groupOptions = {
          chart: {
            type: "radialBar",
            height:'100px',

            offsetY: -20,
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: "97%",
                margin: 5, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  color: "#999",
                  opacity: 1,
                  blur: 2,
                },
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: -2,
                  fontSize: "22px",
                },
              },
            },
          },
          grid: {
            padding: {
              top: -10,
            },
          },
          colors: [function({ value, seriesIndex, w }) {
  if (value <= 25) {
      return '#d00e1f'
  } else if (value > 25 && value <= 75) {
      return '#F9D31A'
  }else {
    return '#97Bf29'
}
}],
          // fill: {
          //   type: "gradient",
          //   gradient: {
          //     shade: "dark",
          //     shadeIntensity: 1,
          //     opacityFrom: 0.7,
          //     opacityTo: 0.9,
          //     colorStops: [
          //       {
          //         offset: 0,
          //         color: "#01defe",
          //         opacity: 1,
          //       },
          //       {
          //         offset: 20,
          //         color: "#1459f3",
          //         opacity: 1,
          //       },
          //     ],
          //   },
          // },
          stroke: {
            lineCap: "round",
          },
          labels: ["Average Results"],
        };

        setRadialChart1(groupOptions);
      }
    },
    [plannedToActual]
  );

  useEffect(
    () => {
      if (timeliness != null) {
        let groupOptions = {
          chart: {
            type: "radialBar",
            offsetY: -20,
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: "97%",
                margin: 5, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  color: "#999",
                  opacity: 1,
                  blur: 2,
                },
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: -2,
                  fontSize: "22px",
                },
              },
            },
          },
          grid: {
            padding: {
              top: -10,
            },
          },
          colors: [function({ value, seriesIndex, w }) {
            if (value <= 25) {
                return '#d00e1f'
            } else if (value > 25 && value <= 75) {
                return '#F9D31A'
            }else {
              return '#97Bf29'
          }
          }],
          // fill: {
          //   type: "gradient",
          //   gradient: {
          //     shade: "dark",
          //     shadeIntensity: 1,
          //     opacityFrom: 0.7,
          //     opacityTo: 0.9,
          //     colorStops: [
          //       {
          //         offset: 0,
          //         color: "#01defe",
          //         opacity: 1,
          //       },
          //       {
          //         offset: 20,
          //         color: "#1459f3",
          //         opacity: 1,
          //       },
          //     ],
          //   },
          // },
          stroke: {
            lineCap: "round",
          },
          labels: ["Average Results"],
        };

        setRadialChart2(groupOptions);
      }
    },
    [timeliness]
  );

  useEffect(
    () => {
      if (failureToActionPlan != null) {
        let groupOptions = {
          chart: {
            type: "radialBar",
            offsetY: -20,
            sparkline: {
              enabled: true,
            },
          },
          plotOptions: {
            radialBar: {
              startAngle: -90,
              endAngle: 90,
              track: {
                background: "#e7e7e7",
                strokeWidth: "97%",
                margin: 5, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 2,
                  left: 0,
                  color: "#999",
                  opacity: 1,
                  blur: 2,
                },
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  offsetY: -2,
                  fontSize: "22px",
                },
              },
            },
          },
          grid: {
            padding: {
              top: -10,
            },
          },
                   colors: [function({ value, seriesIndex, w }) {
  if (value <= 25) {
      return '#d00e1f'
  } else if (value > 25 && value <= 75) {
      return '#F9D31A'
  }else {
    return '#97Bf29'
}
}],
          // fill: {
          //   type: "gradient",
          //   gradient: {
          //     shade: "dark",
          //     shadeIntensity: 1,
          //     opacityFrom: 0.7,
          //     opacityTo: 0.9,
          //     colorStops: [
          //       {
          //         offset: 0,
          //         color: "#01defe",
          //         opacity: 1,
          //       },
          //       {
          //         offset: 20,
          //         color: "#1459f3",
          //         opacity: 1,
          //       },
          //     ],
          //   },
          // },
          stroke: {
            lineCap: "round",
          },
          labels: ["Average Results"],
        };

        setRadialChart3(groupOptions);
      }
    },
    [failureToActionPlan]
  );

  useEffect(
    () => {
      if (auditFrequency != []) {
        let groupOptions = {
          series: Object.values(auditFrequency),
          options: {
            chart: {
              width: 380,
              type: 'pie',
            },
            colors: [
              "#8E4CA3","#1B81C2","#67AEE4","#97BF29","#F9D31A","#FE9C1D","#d00e1f"
                  ],
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val + "%"
              },
            },
        
            labels: Object.keys(auditFrequency),
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,  
                },
               
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
        
        
        };

        setChartNew(groupOptions);
      }
    },
    [auditFrequency]
  );

  const selectResponse = async (e) => {
    console.log("current Response ID ", e.target.value);
    console.log("companyID ", companyID ? companyID : company.id);
    console.log("To Date ", to);
    console.log("From Date ", from);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      response_id: e.target.value,
      from_date: from,
      to_date: to,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    await fetch(GlobalApi + "/Dashboard/on_response_changes?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          console.log("DATA FROM Second Api", response);
          let data = [];
          let total = 0;
          response.data.forEach((item) => {
            total = total + parseInt(item.count);
          });

          console.log("TOTAL COUNT ", total);
          let newRes = [["complete", "incomplete"]];
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              newRes.push([item.title, parseInt(item.count)]);
              data.push({ title: item.title, score: parseInt(item.count) });
            });
          }

          console.log(newRes);
          setCurrentResponses(data);
          setResponses(newRes);
          // if (isNaN(response.plannedToActualRatio)) {
          //   setPlannedToActual(0);
          // } else {
          //   setPlannedToActual(response.plannedToActualRatio);
          // }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            selectResponse();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const classes = useStyles();

  console.log("auditFrequency", auditFrequency);

  return (
    <Grid
      container
      spacing={0}
      style={{
        justifyContent: "space-between",
        flexDirection: "column",
        backgroundColor: Colors.globalColor9,
        marginTop: "0px", boxShadow: "none" 
      }}
      justifyContent="space-between"
      className="fliterBox"
  
    >
      {/* ================================== Section 1 Begins =================================== */}
      <Grid item xs={12} justifyContent="center" alignItems="center">
        <div style={{ width: "100%", padding: "10px", backgroundColor:"white" }}>
          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            className="fliterBox"
            style={{ padding: "5px", boxShadow: "none" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
              
                  display: "flex",
                  overflow: "hidden",
                }}
              >
                <Grid
                  container
                  spacing={0}
                  justifyContent="center"
                  alignItems="center"
                  style={{ padding: "10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: "2" }}>
                        <p
                          className="filterText1"
                          style={{
                            textAlign: "left",
                            color: Colors.globalColor8,
                            margin: "5px",
                          }}
                        >
                          {t("Planned To Actual Ratio")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip  title={t("Average of inspections conducted against scheduled inspections.")}>
                          <HelpOutlineIcon
                            style={{
                              color: Colors.globalColor8,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    spacing={0}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                      {plannedToActualLoader ? (
                       <div style={{ display: "flex", height:'130px', justifyContent: "center", alignItems: "center", width: "100%", marginTop:"5px", }}><Spinner /></div>
                      ) : (
                        <>
                          {plannedToActual == undefined ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                padding: "10px 30px",
                              }}
                            >
                              <Chart
                                options={{
                                  chart: {
                                    type: "radialBar",
                                    height:'100px',
                        
                                    offsetY: -20,
                                    sparkline: {
                                      enabled: true,
                                    },
                                  },
                                  plotOptions: {
                                    radialBar: {
                                      startAngle: -90,
                                      endAngle: 90,
                                      track: {
                                        background: "#e7e7e7",
                                        strokeWidth: "97%",
                                        margin: 5, // margin is in pixels
                                        dropShadow: {
                                          enabled: true,
                                          top: 2,
                                          left: 0,
                                          color: "#999",
                                          opacity: 1,
                                          blur: 2,
                                        },
                                      },
                                      dataLabels: {
                                        name: {
                                          show: false,
                                        },
                                        value: {
                                          offsetY: -2,
                                          fontSize: "22px",
                                        },
                                      },
                                    },
                                  },
                                  grid: {
                                    padding: {
                                      top: -10,
                                    },
                                  },
                                  stroke: {
                                    lineCap: "straight",
                                  },
                                  labels: ["Average Results"],
                                }}
                                series={[parseInt(0)]}
                                // series={[parseInt(20)]}
                                type="radialBar"
                               
                              />
                            </div>
                          ) : (
                            <>
                              <Chart
                                options={radialChart1}
                                series={[parseInt(plannedToActual)]}
                                // series={[parseInt(20)]}
                                type="radialBar"
                               
                              />
                              {/* <GoogleChart chartType="PieChart" loader={<div>
                            Loading Chart
                          </div>} data={[["complete", "incomplete"], ["complete", parseInt(plannedToActual)], ["incomplete", parseInt(100 - plannedToActual)]]} options={{ colors: ["#043077", "#1abba3", "#57e8b5", "#a9fbcd"], backgroundColor: "transparent", width: 150, height: 150, chartArea: { width: "100%", height: "80%" }, legend: { position: "none" }, pieHole: 0.4 }} rootProps={{ "data-testid": "3" }} /> */}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
                
                  display: "flex",
                  overflow: "hidden",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  style={{ padding: "10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: "2" }}>
                        <p
                          className="filterText1"
                          style={{
                            textAlign: "left",
                            color: Colors.globalColor8,
                            margin: "5px",
                          }}
                        >
                          {t("Timeliness Score")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("How timely the inspections are being completed.")}>
                          <HelpOutlineIcon
                            style={{
                              color: Colors.globalColor8,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      {timelinessLoader ? (
                        <div style={{ display: "flex", height:'130px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div>
                      ) : (<>
                         {timeliness == undefined ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "10px 30px",
                          }}
                        >
                          <Chart
                                options={{
                                  chart: {
                                    type: "radialBar",
                                    height:'100px',
                        
                                    offsetY: -20,
                                    sparkline: {
                                      enabled: true,
                                    },
                                  },
                                  plotOptions: {
                                    radialBar: {
                                      startAngle: -90,
                                      endAngle: 90,
                                      track: {
                                        background: "#e7e7e7",
                                        strokeWidth: "97%",
                                        margin: 5, // margin is in pixels
                                        dropShadow: {
                                          enabled: true,
                                          top: 2,
                                          left: 0,
                                          color: "#999",
                                          opacity: 1,
                                          blur: 2,
                                        },
                                      },
                                      dataLabels: {
                                        name: {
                                          show: false,
                                        },
                                        value: {
                                          offsetY: -2,
                                          fontSize: "22px",
                                        },
                                      },
                                    },
                                  },
                                  grid: {
                                    padding: {
                                      top: -10,
                                    },
                                  },
                                  stroke: {
                                    lineCap: "straight",
                                  },
                                  labels: ["Average Results"],
                                }}
                                series={[parseInt(0)]}
                                // series={[parseInt(20)]}
                                type="radialBar"
                               
                              />
                        </div>
                      ) : (
                        <>
                          <Chart
                            options={radialChart2}
                            series={[parseInt(timeliness)]}
                            type="radialBar"
                            width="100%"
                          />
                          {/* <GoogleChart chartType="PieChart" loader={<div>
                            Loading Chart
                          </div>} data={[["complete", "incomplete"], ["complete", parseInt(timeliness)], ["incomplete", parseInt(100 - timeliness)]]} options={{ colors: ["#043077", "#1abba3", "#57e8b5", "#a9fbcd"], backgroundColor: "transparent", width: 150, height: 150, chartArea: { width: "100%", height: "80%" }, legend: { position: "none" }, pieHole: 0.4 }} rootProps={{ "data-testid": "3" }} /> */}
                        </>
                      )}
                      </>)}
                   
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "200px",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
              
                  display: "flex",
                  overflow: "hidden",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  style={{ padding: "10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: "2" }}>
                        <p
                          className="filterText1"
                          style={{
                            textAlign: "left",
                            color: Colors.globalColor8,
                            margin: "5px",
                          }}
                        >
                          {t("Failure To Action Plan Ratio")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("Percentage of counter actions against failed items.")}>
                          <HelpOutlineIcon
                            style={{
                              color: Colors.globalColor8,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    className="chartHolder"
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                        {failureToActionLoader ? (
                        <div style={{ display: "flex", height:'130px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div>
                      ) : (<> {failureToActionPlan == undefined ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "10px 30px",
                          }}
                        >
                         <Chart
                                options={{
                                  chart: {
                                    type: "radialBar",
                                    height:'100px',
                        
                                    offsetY: -20,
                                    sparkline: {
                                      enabled: true,
                                    },
                                  },
                                  plotOptions: {
                                    radialBar: {
                                      startAngle: -90,
                                      endAngle: 90,
                                      track: {
                                        background: "#e7e7e7",
                                        strokeWidth: "97%",
                                        margin: 5, // margin is in pixels
                                        dropShadow: {
                                          enabled: true,
                                          top: 2,
                                          left: 0,
                                          color: "#999",
                                          opacity: 1,
                                          blur: 2,
                                        },
                                      },
                                      dataLabels: {
                                        name: {
                                          show: false,
                                        },
                                        value: {
                                          offsetY: -2,
                                          fontSize: "22px",
                                        },
                                      },
                                    },
                                  },
                                  grid: {
                                    padding: {
                                      top: -10,
                                    },
                                  },
                                  stroke: {
                                    lineCap: "straight",
                                  },
                                  labels: ["Average Results"],
                                }}
                                series={[parseInt(0)]}
                                // series={[parseInt(20)]}
                                type="radialBar"
                               
                              />
                        </div>
                      ) : (
                        <div style={{ width: "100%", height: "100%" }}>
                          <Chart
                            options={radialChart3}
                            series={[parseInt(failureToActionPlan)]}
                            type="radialBar"
                            width="100%"
                          />
                          {/* <GoogleChart chartType="PieChart" loader={<div>
                            Loading Chart
                          </div>} data={[["complete", "incomplete"], ["complete", parseInt(failureToActionPlan)], ["incomplete", parseInt(100 - failureToActionPlan)]]} options={{ colors: ["#043077", "#1abba3", "#57e8b5", "#a9fbcd"], backgroundColor: "transparent", width: 150, height: 150, chartArea: { width: "100%", height: "80%" }, legend: { position: "none" }, pieHole: 0.4 }} rootProps={{ "data-testid": "3" }} /> */}
                        </div>
                      )}</>)}
                      
                     
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
            className="fliterBox"
            style={{ padding: "5px", boxShadow: "none" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
                  display: "flex",
                  overflow: "hidden",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  style={{ padding: "10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: "2" }}>
                        <p
                          className="filterText1"
                          style={{
                            textAlign: "left",
                            color: Colors.globalColor8,
                            margin: "5px",
                          }}
                        >
                          {t("Action Plan To Resolution")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("Classified data for the time taken by counter actions.")}>
                          <HelpOutlineIcon
                            style={{
                              color: Colors.globalColor8,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                    {actionPlanLoader ? (
                        <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div>
                      ) : (<>
                      {actionPlan == undefined ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "0px",
                          }}
                        >
                           <Chart
                            options={chart1.options}
                            series={[{ data: [] }]}
                            type="bar"
                            height={230}
                            width={"100%"}
                          />
                        </div>
                      ) : (
                        <div id="chart">
                          <Chart
                            options={chart1.options}
                            series={[{ data: actionPlan }]}
                            type="bar"
                            height={200}
                            width={"100%"}
                          />
                        </div>
                      )}
                      </>)}

                      

                      {/* <GoogleChart chartType="Bar" loader={<div>
                        Loading Chart
                      </div>} data={[["Year", "Sales"], ["2014", 1000], ["2015", 1170], ["2016", 660], ["2017", 1030]]} options={{ colors: ["#043077", "#1abba3", "#57e8b5", "#a9fbcd"], backgroundColor: "transparent", width: "100%", height: 200, chartArea: { width: "100%", height: "80%" }, legend: { position: "none" }, pieHole: 0.4 }} rootProps={{ "data-testid": "2" } // For tests
                    } /> */}
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  overflow: "hidden",
                  display: "flex",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
                }}
              >
                <div
                  className="scrollHidden"
                  style={{
                    width: "100%",

                  }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <Grid
                      item
                      xs={12}
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ flex: "2" }}>
                          <p
                            className="filterText1"
                            style={{
                              textAlign: "left",
                              color: Colors.globalColor8,
                              margin: "5px",
                            }}
                          >
                            {t("Bottom 10 Inspected Areas")}
                          </p>
                        </div>
                        <div style={{ flex: "1", textAlign: "right" }}>
                          <Tooltip title={t("Most problematic areas which are at high risks and require immediate actions to resolve.")}>
                            <HelpOutlineIcon
                              style={{
                                color: Colors.globalColor8,
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      justifyContent="center"
                      alignItems="center"
                      style={{ padding: "10px" }}
                    >
                      <div style={{ width: "100%" }}>
                      {bottomAreasLoader ? (
                        <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div>
                      ) : (<>  {bottomAreas.length == 0 && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "0px",
                          }}
                        >

                         <TableHead style={{ width: "100%", backgroundColor:"#f2f2f2", border:'1px solid #dadada' }}>
                              <TableRow>
                                <TableCell
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  {" "}
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Areas")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Current Score")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Previous Score")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Trends")}
                                  </p>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                        </div>
                      )}

                      {bottomAreas.length > 0 && (
                        <TableContainer
                          style={{
                            width: "100%",
                            border: "1px solid #dadada",
                            maxHeight:'230px'
                          }}
                        >
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead style={{ width: "100%", backgroundColor:"#f2f2f2" }}>
                              <TableRow>
                                <TableCell
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  {" "}
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Areas")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Current Score")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Previous Score")}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ width: "25%", padding: "5px" }}
                                >
                                  <p
                                    className="filterText1"
                                    style={{
                                      lineHeight: "1",
                                      marginTop: "0px",
                                      marginBottom: "0px",
                                      textAlign: "center",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {t("Trends")}
                                  </p>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {bottomAreas.map((row) => (
                                <TableRow key={row.name}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ width: "25%",padding: "8px",fontSize:'10px' }}
                                  >
                                    <Tooltip title={row.title}>
                                      <div>
                                        {row.title.slice(0, 20) +
                                          (row.title.length > 20
                                            ? "..."
                                            : "")}
                                      </div>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "25%",
                                      padding: "8px",
                                      fontSize:'10px'
                                    }}
                                  >
                                    {parseInt(row.current_score)}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "25%",
                                      padding: "8px",
                                      fontSize:'10px'
                                    }}
                                  >
                                    {parseInt(row.prev_score)}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    style={{
                                      width: "25%",
                                      padding: "8px",
                                      fontSize:'10px'
                                    }}
                                  >
                                    {parseInt(row.current_score) >
                                      parseInt(row.prev_score) && (
                                      <img src={up} width={20} />
                                    )}

                                    {parseInt(row.prev_score) >
                                      parseInt(row.current_score) && (
                                      <img src={down} width={20} />
                                    )}

                                    {parseInt(row.prev_score) ==
                                      parseInt(row.current_score) && (
                                      <img src={dots} width={20} />
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}</>)}
                      
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              lg={4}
              justifyContent="center"
              alignItems="center"
            >
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  borderRadius: "10px",
                  border: "1px solid #dadada",
                  display: "flex",
                  overflow: "hidden",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                  style={{ padding: "10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ flex: "2" }}>
                        <p
                          className="filterText1"
                          style={{
                            textAlign: "left",
                            color: Colors.globalColor8,
                            margin: "5px",
                          }}
                        >
                          {t("Inspection Frequency Types")}
                        </p>
                      </div>
                      <div style={{ flex: "1", textAlign: "right" }}>
                        <Tooltip title={t("The analysis indicates how the inspection team work is being planned.")}>
                          <HelpOutlineIcon
                            style={{
                              color: Colors.globalColor8,
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    justifyContent="center"
                    alignItems="center"
                    style={{ padding: "10px" }}
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                    {/* <Chart options={chartNew.options} series={chartNew.series} type="pie" width={380} /> */}
                    {auditFrequencyLoader ? (
                        <div style={{ display: "flex", height:'230px', justifyContent: "center", alignItems: "center", width: "100%", }}><Spinner /></div>
                      ) : (<>{auditFrequency.length == 0 ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "30px",
                          }}
                        >
                          <img src={NoRecord} width={"200px"} alt="no Record" />
                        </div>
                      ) : (
                        // <GoogleChart
                        //   chartType="PieChart"
                        //   loader={<div />}
                        //   data={[
                        //     ["Year", "Sales"],
                        //     [
                        //       "Custom Month Avg",
                        //       auditFrequency.custom_month_avg,
                        //     ],
                        //     [
                        //       "Custom Week Avg",
                        //       auditFrequency.custom_week_avg / 100,
                        //     ],
                        //     [
                        //       "Custom Day Avg",
                        //       auditFrequency.custom_day_avg / 100,
                        //     ],
                        //     [
                        //       "Every Month Avg",
                        //       auditFrequency.every_month_avg / 100,
                        //     ],
                        //     [
                        //       "Every Week Avg",
                        //       auditFrequency.every_week_avg / 100,
                        //     ],
                        //     [
                        //       "Every weekDay Avg",
                        //       auditFrequency.every_weekDay_avg / 100,
                        //     ],
                        //     ["One Off Avg", auditFrequency.one_off_avg / 100],
                        //   ]}
                        //   options={{
                        //     colors: [
                        //       "#16234d",
                        //       "#2a428c",
                        //       "#3657b6",
                        //       "#4c78d9",
                        //       "#639df1",
                        //       "#8ecefc",
                        //       "#aee8fe",
                        //       "#d8f9ff",
                        //       "#f2fdff",
                        //     ],
                        //     backgroundColor: "transparent",
                        //     width: "100%",
                        //     height: 200,
                        //     chartArea: {
                        //       width: "100%",
                        //       height: "80%",
                        //       backgroundColor: "transparent",
                        //     },
                        //     legend: { position: "bottom" },
                        //     pieHole: 0,
                        //   }}
                        //   rootProps={
                        //     { "data-testid": "2" } // For tests
                        //   }
                        // />

                        <Chart options={chartNew.options} series={chartNew.series} type="pie" width={380} />
                      )}</>)}
                      
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/* ================================== Section 3 Ends =================================== */}
    </Grid>
  );

  {
    /* ================================== Main Area Begins =================================== */
  }

  {
    /* ================================== Filter Bar Begins =================================== */
  }
  {
    /* 
        <Grid container spacing={1} style={{ justifyContent: "space-between" }} justifyContent="space-between" alignItems="center" className="fliterBox" style={{ padding: "5px" }}>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <p className="filterText1" style={{ textAlign: "left", color: Colors.globalColor8 }}>
              Search & Filters
            </p>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" placeholder="select Company" variant="outlined" size="small">
              <MenuItem value="">Select Company</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Template</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Site</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Select className="SelectBox" style={{ minWidth: 170 }} defaultValue="" variant="outlined" size="small">
              <MenuItem value="">Select Inspector</MenuItem>
              <MenuItem value={10}>Ten</MenuItem>
              <MenuItem value={20}>Twenty</MenuItem>
              <MenuItem value={30}>Thirty</MenuItem>
            </Select>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center" style={{ minWidth: "150px" }}>
            <Grid container spacing={1}>
              <Grid item>
                <img src={calander} width={35} />
              </Grid>
              <Grid item>
                <Grid container style={{ display: "flex", flexDirection: "column" }}>
                  <p className="filterText1" style={{ textAlign: "left", display: "inline-block", fontSize: "10px", marginTop: 0, marginBottom: 0 }}>
                    From
                  </p>
                  <p className="filterText1" style={{ textAlign: "left", fontSize: "10px", display: "inline-block", marginTop: 0, marginBottom: 0 }}>
                    11/12/2022
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center" style={{ minWidth: "150px", display: "flex", justifyContent: "center", textAlign: "center" }}>
            <Grid container spacing={1}>
              <Grid item>
                <img src={calander} width={35} />
              </Grid>
              <Grid item>
                <Grid container style={{ display: "flex", flexDirection: "column" }}>
                  <p className="filterText1" style={{ textAlign: "left", display: "inline-block", fontSize: "10px", marginTop: 0, marginBottom: 0 }}>
                    To
                  </p>
                  <p className="filterText1" style={{ textAlign: "left", fontSize: "10px", display: "inline-block", marginTop: 0, marginBottom: 0 }}>
                    11/12/2022
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs="auto" justifyContent="center" alignItems="center">
            <Button variant="contained" style={{ backgroundColor: Colors.globalColor8 }}>
              <p className="filterText1" style={{ textAlign: "left", color: "white", marginTop: 0, marginBottom: 0 }}>
                Apply
              </p>
            </Button>
          </Grid>
        </Grid> */
  }
  {
    /* ================================== Filter Bar Ends =================================== */
  }
}

export default ExecutiveDashboard;
